export default {
  // errors
  UNAUTHORIZED: 401,
  INCORRECT_LOGIN_CREDENTIALS: 403,
  RECORD_NOT_FOUND: 404,
  SYSTEM_EXCEPTION: 500,
  CLIENT_ERROR: 1000,

  // events
  LOGOUT: 'logout',
  FORCE_LOGOUT: 'force_logout',
  LOGOUT_BY_ROLE: 'logout_by_role',
  ALERT: 'alert',
  ADMIN_MAX_PASSWORD_LENGTH: 32,
  ONE_MB: 1000000, // 1 Mb to byte
  TOAST_NOTIFICATION_DURATION: 5000, // 2 seconds
  ITEMS_PER_PAGE: 25,
};
